import { ItemsCountWithoutSuccess } from "@/models/Backlog"
import { Project } from "@/models/Project"

import { AiStructuredContent } from "./AI"
import { ItemInSprintReview } from "./Item"
import { Sprint, SprintMetrics } from "./Sprint"

export class SprintReviewMetrics {
  completed = 0
  remaining = 0
  blocked = 0
  notStarted = 0
  carriedForward = 0
  movedToAnotherTeam = 0

  constructor(props?: Partial<SprintReviewMetrics>) {
    if (!props) return
    Object.keys(props).forEach(field => {
      this[field] = props[field]
    })
  }
}

export class SprintReviewContent {
  id = ""
  projectId = ""
  createdDate = ""
  items: ItemInSprintReview[] = []
  generalReview: SprintReviewMetrics = new SprintReviewMetrics()
  sprintReviewByProject: { [key: string]: SprintReviewMetrics } = {}

  constructor(props?: Partial<SprintReviewContent>) {
    if (!props) return
    Object.keys(props).forEach(field => {
      this[field] = props[field]
    })
    this.items = this.items.map(e => ItemInSprintReview.create(e))
    if (props.generalReview) {
      this.generalReview = new SprintReviewMetrics(
        props.generalReview as Partial<SprintReviewMetrics>
      )
    }
    if (props.sprintReviewByProject) {
      this.sprintReviewByProject = Object.fromEntries(
        Object.entries(props.sprintReviewByProject).map(([key, value]) => [
          key,
          new SprintReviewMetrics(value as Partial<SprintReviewMetrics>)
        ])
      )
    }
  }
}

export interface SprintInsights {
  content: string
  structuredContent?: AiStructuredContent
  createdAt: string
  isDefaultTokenUsed: boolean
}

export class SprintReview {
  sprint: Sprint
  stats: SprintMetrics
  review: SprintReviewContent
  projects: Project[]
  projectCarriedForwardItemSummaryDto?: ItemsCountWithoutSuccess
  projectCarryOverItemSummaryDto?: ItemsCountWithoutSuccess
  projectCompletedItemSummaryDto?: ItemsCountWithoutSuccess
  insights?: SprintInsights

  constructor(props?) {
    this.setDefaultData()

    if (!props) return
    this.sprint = Sprint.create(props.sprint)
    this.stats = props.stats
    this.review = new SprintReviewContent(props.review)
    this.projects = props.projects ? props.projects.map(e => Project.create(e)) : []
    this.projectCarriedForwardItemSummaryDto = props.projectCarriedForwardItemSummaryDto
    this.projectCompletedItemSummaryDto = props.projectCompletedItemSummaryDto
    this.projectCarryOverItemSummaryDto = props.projectCarryOverItemSummaryDto
    this.insights = props.insights
  }

  setDefaultData() {
    this.review = new SprintReviewContent()
    this.sprint = new Sprint()
    // this.stats = {}
  }

  static create(props: SprintReview): SprintReview {
    return new SprintReview(props)
  }
}
